import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bdd_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export const STORE_LABEL = {
  amazon: "Amazon",
  aliexpress: "AliExpress",
  ebay: "eBay",
  altro: "Altro",
};

export const STORE_COLOR = {
  amazon: "#FF9900",
  aliexpress: "#FF4747",
  ebay: "#86B817",
  altro: "#A1A1AA",
};

export function priceFmt(n) {
  if (n === null || n === undefined) return "";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(n);
}

// Return the clean display title for a deal, falling back to the raw marketplace title.
export function dealTitle(d) {
  if (!d) return "";
  return (d.title_display && d.title_display.trim()) || d.title || "";
}
